import axios from 'axios'

import { IAuthInfoResponse } from './types'

/**
 * The address-to-account lookup, with no side effects: it opens no modals and touches
 * no state, so both the email step and the platform flows can share it.
 */
export const fetchAuthInfo = async (email: string, signal?: AbortSignal): Promise<IAuthInfoResponse> => {
  const response = await axios.post<IAuthInfoResponse>(`${process.env.REACT_APP_API_URL}/core/auth-lookup`, { email }, signal ? { signal } : undefined)
  return response.data
}

export const isInactiveAccountError = (error): boolean => error?.response?.data?.code === 'EmailPlatformUserInactive'

/**
 * One address can hold an account per platform, so "this address has a live account" is not
 * an answer about the platform being signed in with: a visitor whose Slack account was
 * deactivated while their Teams account stayed live passed this check and was turned away by
 * Cognito instead. `availablePlatforms` is the precise answer; deployments that answer
 * without it can say no more than the response already did.
 */
export const canSigninWithPlatform = (info: IAuthInfoResponse, platform: string): boolean => (info.availablePlatforms ? info.availablePlatforms.includes(platform) : true)

export const readOrganizationName = (error): string | undefined => {
  const companyName = error?.response?.data?.data?.companyName
  return typeof companyName === 'string' && companyName ? companyName : undefined
}
